import { Col, Container, Row } from "react-bootstrap"
import styles from "./SolarComponent.module.css"
import CustomCard from "../CustomCard/CustomCard"
import PurpleSection from "../PurpleSection/PurpleSection"
import ContactBanner from "../ContactBanner/ImageBanner"
import { useContext, useEffect } from "react"
import { CollapseContext } from "../../context/collapse.context"

const CARDS = {
  CARD1: {
    img: "https://res.cloudinary.com/dzzkeb6xp/image/upload/v1679137957/ONTOV20_buletl.jpg",
    alt: "Casa con autoconsumo solar",
    title: "Aprovecha tu potencial",
    description:
      "Aprovecha tus infraestructuras para generar y producir grandes cantidades de energía renovable, consiguiendo asi Ahorro, Aumento del valor de la propiedad",
  },
  CARD2: {
    img: "https://res.cloudinary.com/dzzkeb6xp/image/upload/v1679137678/11009_mgqluy.jpg",
    alt: "Persona en burbuja",
    title: "Despreocúpate",
    description:
      "Nosotros nos encargamos: permisos de obra, subvenciones, financiación, mantenimiento y resolución de incidencias.",
  },
  CARD3: {
    img: "https://res.cloudinary.com/dzzkeb6xp/image/upload/v1679137537/ilustracion-soporte-al-cliente-plano-organico_23-2148899173_pdltgt.avif",
    alt: "Soporte al cliente",
    title: "Nos ajustamos a ti",
    description:
      "Cada cliente tiene necesidades únicas, estudiamos y evaluamos tus necesidades y proyectos para ofrecer el mejor servicio a medida",
  },
}
const SolarComponent: React.FC = () => {
  const { setCollapse } = useContext<any>(CollapseContext)
  useEffect(() => {
    setCollapse(false)
  }, [])
  return (
    <>
      <div className={styles.main}>
        <div className={styles.mainSection}>
          <div className={styles.fontPosition}>
            <h1 className={styles.fontSize}>
              Placas solares, Cargadores para vehículos Baterías y mucho más...
            </h1>
          </div>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col
            lg={{ span: 12 }}
            style={{
              marginTop: "4%",
              textAlign: "center",
            }}
          >
            <h2 className={styles.fontSizeSm}> Genera tu propia energía</h2>
            <p>Descentraliza la generación energética</p>
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 12 }} className={styles.solarImg}></Col>
        </Row>
      </Container>
      <br />
      <PurpleSection
        title={"Genera el máximo potencial de tu infraestructura"}
        description={
          "Empieza a generar energía renovable mientras ahorras en tus facturas"
        }
      />

      <Container fluid style={{ marginBottom: "5%" }}>
        <Row>
          <Col
            lg={{ span: 12 }}
            style={{
              marginTop: "4%",
              textAlign: "center",
            }}
          >
            <h2 className={styles.fontSizeSm}>Ventajas que ofrece Fiva</h2>
            <p>¿Por qué nosotros?</p>
          </Col>
        </Row>
        <Row className={styles.customCard}>
          <CustomCard {...CARDS.CARD1} />
          <CustomCard {...CARDS.CARD2} />
          <CustomCard {...CARDS.CARD3} />
        </Row>
      </Container>
      <br />
      <br />
      <ContactBanner />
      <br />
      <br />
    </>
  )
}

export default SolarComponent
